import http from './axios'
import { InstitutioninforApi, UserprojectdatarelationApi, RoleinforApi } from "@newview/system-api";
import { ActreflowConditionApi } from "@newview/basics-v2-api";
import { BaseVue } from "@newview/base-web";
import { QueryWrapper } from '@newview/Core/infrastructure';

let baseUrl = "."

/**
 * 获取角色
 * @param {*} data 
 * @returns 
 */
export const getRoles = async (projectId, roleName = "") => {
  let roleinforApi: RoleinforApi = new RoleinforApi();
  let baseVue = new BaseVue();
  let apiResult = await roleinforApi.getFlowRoleVoes(projectId);
  let roles: any[] = baseVue.parseApiResult(apiResult);

  if (roleName != "") {
    roles = roles.filter(item => item.roleName.indexOf(roleName) != -1);
  }

  return roles;
}

/**
 * 获取部门
 * @param {*} data 
 * @returns 
 */
export const getDepartments = async (parentId, projectId) => {
  const institutioninforApi: InstitutioninforApi = new InstitutioninforApi();
  const userprojectdatarelationApi: UserprojectdatarelationApi = new UserprojectdatarelationApi();
  const parseDepartment = (item) => {
    return {
      departmentId: item.id,
      departmentKey: item.id,
      departmentName: item.institutionName,
      id: item.id,
      parentId: item.PId,
      departmentNames: item.institutionName
    }
  }

  let baseVue = new BaseVue();
  let apiResult = await institutioninforApi.getInstitutionTreeBySubProjectIdNew(projectId);
  const datas: any[] = baseVue.parseApiResult(apiResult);

  // 机构列表  
  const childDepartments: any[] = datas.filter(item => item.PId == parentId).map((item) => {
    return parseDepartment(item);
  });

  // 用户列表  
  let employees: any[] = [];
  if (parentId > 0) {
    let param: any = {
      projectDataId: projectId,
      institutionId: parentId
    }
    let result = await userprojectdatarelationApi.getUserList(param, 1, 10000, "", "", "", 0);
    if (result.code == 200) {
      employees = result.data.records;
      employees = employees.map(item => {
        return {
          id: item.id,
          employeeName: item.userTrueName,
          isLeave: "0",
          open: "false"
        }
      })
    }
  }

  // 获取当前节点及上级节点
  let titleDepartments: any[] = [];
  const addNode = (id) => {
    const values = datas.filter(item => item.id == id);
    if (values.length == 0) {
      return;
    }

    titleDepartments.push(parseDepartment(values[0]));
    addNode(values[0].PId);
  };
  addNode(parentId);
  titleDepartments = titleDepartments.reverse();

  return {
    childDepartments: childDepartments,
    employees: employees,
    titleDepartments: titleDepartments
  };
}

/**
 * 获取职员
 * @param {*} data 
 * @returns 
 */
export const getEmployees = async (parentId, projectId, userName) => {
  const userprojectdatarelationApi: UserprojectdatarelationApi = new UserprojectdatarelationApi();

  let employees: any[] = [];
  let param: any = {
    projectDataId: projectId,
    institutionId: parentId
  }
  let result = await userprojectdatarelationApi.getUserList(param, 1, 10000, userName, "", "", 0);
  if (result.code == 200) {
    employees = result.data.records;
    employees = employees.map(item => {
      return {
        id: item.id,
        employeeName: item.userTrueName,
        isLeave: "0",
        open: "false"
      }
    })
  }

  return employees;
}
/**
 * 获取条件字段
 * @param {*} data 
 * @returns 
 */
export const getConditions = async (data) => {
  const actreflowConditionApi: ActreflowConditionApi = new ActreflowConditionApi();
  const baseVue = new BaseVue();
  const apiResult = await actreflowConditionApi.getEntities(baseVue.getQueryWrapper().eq("FlowId", data.tableId));
  const datas: any[] = baseVue.parseApiResult(apiResult);

  let newDatas: any[] = datas.map(item => {
    return {
      columnId: `${item.Id}`, // 类型为发起人时 columnId = "0"
      showType: item.ShowType,
      showName: item.ShowName,
      columnName: item.ColumnName,
      columnType: item.ColumnType,
      fixedDownBoxValue: item.FixedDownBoxValue
    }
  });

  return { data: newDatas }
}